var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-column"},[_c('GamesSearchBoxConnected',{staticClass:"mb3",staticStyle:{"height":"256px"}}),_c('KeyboardBoxConnected',{staticClass:"w-80 center"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }